<template>
  <div>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <div class="card-body text-center">
      <div class="card-title text-center">
        <h3>Eboard service</h3>
      </div>
      <form @submit.prevent>
        <h5 class="text-left mb-3">Visual inspection</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.contentDispCorrect">
            Make sure content is displayed correctly
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.noBlankScreen">
            No blank screen or tiles
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.logoMatchesLocation">
            Welcome message and host logo matches location
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.standDisplaced">
            Report immediatly if stand has been displaced
          </base-checkbox>
        </div>
        <h5 class="text-left mt-4 mb-3">Cleaning</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.cleanBody">
            Clean body of stand
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.cleanScreen">
            Turn off monitor and clean screen
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.cleanPlayer">
            Clean player, use air cannister to dust
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.cablesConnectedTightly">
            Check that all cables and plugs are connected tightly
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.reboot">
            Reboot
          </base-checkbox>
        </div>
        <h5 class="text-left mt-4 mb-3">Connectivity - After Reboot</h5>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.pickupsIpAdress">
            Make sure player picks up IP adress
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.mapsDisplayCorrec">
            Make sure maps display correctly
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.verifyEmailTextWork">
            Verify email and text work
          </base-checkbox>
        </div>
        <h4 class="text-left mt-2 mb-2">Report outstanding issues to Ops Manager</h4>
        <h4 class="text-left mt-2 mb-2">Notify Ettraction immediately if board is not working properly 1-888-303-0615</h4>
        <h5 class="text-left mt-4 mb-3">Document visit</h5>
        <div class="form-group text-left">
          <label >Picture</label>
          <div>
            <a v-on:click='takePicture(["eboardService", "pictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{eboardService.pictures.length}}</badge>
            <p v-if="showErrorPictures"><span class="errorimagesquantity">Min 1 picture required</span></p>
          </div>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.standCleaned">
            Stand cleaned
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <base-checkbox
            class="mb-1"
            v-model="eboardService.troubleshooting">
            Troubleshooting
          </base-checkbox>
          <label >Will send email to Ettractions</label>
        </div>
        <div class="form-group text-left">
          <base-checkbox v-model="eboardService.headerInstallation">
            Header installation
          </base-checkbox>
        </div>
        <div class="form-group text-left">
          <label for="eboardProblem">Problem</label>
          <textarea class="form-control" id="eboardProblem" v-model="eboardService.eboardProblem" name="eboardProblem" rows="3"></textarea>
        </div>
        <div class="text-center">
          <base-button :disabled="disableSubmitButton" v-if="showSubmitButton() && !isJobActionCopleted(2)" type="primary" @click="eboardServiceSend" size='md' class="my-4">Submit</base-button>
        </div>
      </form>
    </div>
  </div>

</template>
<script>
import jobActionFormMixin from './../views/mixins/jobActionFormMixin'
import jobActionsMixin from './../views/mixins/jobActionsMixin'
import standsMixin from './../views/mixins/standsMixin'
import jobsMixin from './../views/mixins/jobsMixin'
import camera from './Camera'
import signatures from './Signatures'
export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null,
      showErrorPictures: false,
      eboardService: {
        contentDispCorrect: null,
        noBlankScreen: null,
        logoMatchesLocation: null,
        standDisplaced: null,
        cleanBody: null,
        cleanScreen: null,
        cleanPlayer: null,
        cablesConnectedTightly: null,
        reboot: null,
        pickupsIpAdress: null,
        mapsDisplayCorrec: null,
        verifyEmailTextWork: null,
        pictures: [],
        standCleaned: null,
        headerInstallation: null,
        eboardProblem: null,
        troubleshooting: null
      }
    }
  },
  props: {
    disableSubmitButton: {
      type: Boolean,
      default: false,
      description: 'Disable submit button'
    }
  },
  methods: {
    eboardServiceSend () {
      if (!this.eboardService.pictures.length) {
        this.showErrorPictures = true
        return
      }
      this.$emit('eboardServiceFormDataSend', this.eboardService)
    }
  },
  mixins: [jobActionFormMixin, jobActionsMixin, jobsMixin, standsMixin],
  components: {
    camera,
    signatures
  }
}
</script>
<style>
</style>
